// Raccordement gouttière → cuve : toujours nécessaire (au moins une descente), donc ce poste
// est actif par défaut, pas optionnel comme le pompage ou la filtration.
export const COLLECTEUR_FILTRANT_COST = { low: 25, high: 150 }; // par descente raccordée
export const CANALISATION_EUR_PAR_ML = { low: 15, high: 40 }; // canalisation enterrée gouttière → cuve

/**
 * @param {Object} params - { nbDescentes, distance (ml), refined }
 */
export const computeArriveeEauCost = ({ nbDescentes, distance, refined }) => {
  const n = Math.max(1, nbDescentes || 1);
  const breakdown = [{
    name: `Raccordement gouttière (${n} descente${n > 1 ? 's' : ''})`,
    low: n * COLLECTEUR_FILTRANT_COST.low,
    high: n * COLLECTEUR_FILTRANT_COST.high,
  }];
  let low = n * COLLECTEUR_FILTRANT_COST.low;
  let high = n * COLLECTEUR_FILTRANT_COST.high;

  if (refined && distance > 0) {
    const dLow = distance * CANALISATION_EUR_PAR_ML.low;
    const dHigh = distance * CANALISATION_EUR_PAR_ML.high;
    breakdown.push({ name: `Canalisation enterrée jusqu'à la cuve (${distance} ml)`, low: dLow, high: dHigh });
    low += dLow;
    high += dHigh;
  }

  return { breakdown, low, high };
};
